import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

/**
 * Sits under `home` to inherit the real home page's chrome. Staff-gated because
 * an unlinked URL is not a control; the gate comes off at switch-over.
 */
export const plgHomeRoutes: PermissionedRouteObject[] = [
  {
    /** No breadcrumb: the page's own greeting is its heading. */
    handle: { permission: ({ user }) => isRedoEmailAddress(user.email) },
    children: [
      {
        index: true,
        lazy: async () => {
          const { PlgHomepage } = await import("./plg-homepage");
          return { Component: PlgHomepage };
        },
      },
    ],
  },
];
